import * as operationMessage from "./operationMessage";
/* eslint-disable */
// API 更新时间：
// API 唯一标识：
import { request } from "@umijs/max"
import * as five4ApPyonghuzhanghuxinxi from "./five4ApPyonghuzhanghuxinxi"
import * as five5ApPyonghuzhanghudaoru from "./five5ApPyonghuzhanghudaoru"
import * as kongjianguanli from "./kongjianguanli"
import * as nine00Guanlidingshiqishoudongzhixing from "./nine00Guanlidingshiqishoudongzhixing"
import * as one01WeBhuiyuanguanli from "./one01WeBhuiyuanguanli"
import * as one02WeBshangpinguanli from "./one02WeBshangpinguanli"
import * as one03WeBdingdanguanli from "./one03WeBdingdanguanli"
import * as one04WeBzhifuguanli from "./one04WeBzhifuguanli"
import * as one05WeByuyueshiyongguanli from "./one05WeByuyueshiyongguanli"
import * as one06WeBchangguanguanli from "./one06WeBchangguanguanli"
import * as one07WeByongchiguanli from "./one07WeByongchiguanli"
import * as one08WeBtingchechangguanli from "./one08WeBtingchechangguanli"
import * as one09WeBzhajiguanli from "./one09WeBzhajiguanli"
import * as one10WeBshouhuanjiguanli from "./one10WeBshouhuanjiguanli"
import * as one11WeBshouhuanguanli from "./one11WeBshouhuanguanli"
import * as one12WeByuangongguanli from "./one12WeByuangongguanli"
import * as one13WeBjiaoseguanli from "./one13WeBjiaoseguanli"
import * as one14WeBbumenguanli from "./one14WeBbumenguanli"
import * as one15WeBbannerguanli from "./one15WeBbannerguanli"
import * as one16WeBgonggaoguanli from "./one16WeBgonggaoguanli"
import * as one17WeByouhuihuodongguanli from "./one17WeByouhuihuodongguanli"
import * as one18WeBtousuguanli from "./one18WeBtousuguanli"
import * as one19WeBzidianguanli from "./one19WeBzidianguanli"
import * as one20WeBjiaolianguanli from "./one20WeBjiaolianguanli"
import * as one21WeBchangguanyunyingshijianguanli from "./one21WeBchangguanyunyingshijianguanli"
import * as one21WeBnianlingzuguanli from "./one21WeBnianlingzuguanli"
import * as one22WeBshangpinjiagebanbenguanli from "./one22WeBshangpinjiagebanbenguanli"
import * as one23WeBtuijianshangpinguanli from "./one23WeBtuijianshangpinguanli"
import * as one23WeByouyongzheguanli from "./one23WeByouyongzheguanli"
import * as one24WeBshangpinguizeguanli from "./one24WeBshangpinguizeguanli"
import * as one26WeBcaidanguanli from "./one26WeBcaidanguanli"
import * as one27WeBquanxiantiaomu from "./one27WeBquanxiantiaomu"
import * as one30WeBduizhangzhongxin from "./one30WeBduizhangzhongxin"
import * as one99WeBchangguanxiaoxiceshi from "./one99WeBchangguanxiaoxiceshi"
import * as renzhengquanxian from "./renzhengquanxian"
import * as three01Machineshouhuanjihuidiao from "./three01Machineshouhuanjihuidiao"
import * as two00WeByonghuxieyi from "./two00WeByonghuxieyi"
import * as two01ApPhuiyuan from "./two01ApPhuiyuan"
import * as two02ApPbanner from "./two02ApPbanner"
import * as two03ApPchangguan from "./two03ApPchangguan"
import * as two04ApPhuodong from "./two04ApPhuodong"
import * as two05ApPshangpin from "./two05ApPshangpin"
import * as two06ApPgouwuche from "./two06ApPgouwuche"
import * as two07ApPdingdan from "./two07ApPdingdan"
import * as two08ApPyouyongzheguanli from "./two08ApPyouyongzheguanli"
import * as two09ApPyonghuxieyi from "./two09ApPyonghuxieyi"
import * as two10ApPtousufankui from "./two10ApPtousufankui"
import * as two11ApPzhifuguanli from "./two11ApPzhifuguanli"
import * as zero06BasEwenjianguanli from "./zero06BasEwenjianguanli"
export default {
  ...two00WeByonghuxieyi,
  ...one05WeByuyueshiyongguanli,
  ...one23WeByouyongzheguanli,
  ...one12WeByuangongguanli,
  ...kongjianguanli,
  ...one13WeBjiaoseguanli,
  ...one30WeBduizhangzhongxin,
  ...one23WeBtuijianshangpinguanli,
  ...one17WeByouhuihuodongguanli,
  ...one07WeByongchiguanli,
  ...one04WeBzhifuguanli,
  ...one08WeBtingchechangguanli,
  ...one03WeBdingdanguanli,
  ...one16WeBgonggaoguanli,
  ...one99WeBchangguanxiaoxiceshi,
  ...operationMessage,
  ...one01WeBhuiyuanguanli,
  ...one21WeBchangguanyunyingshijianguanli,
  ...one06WeBchangguanguanli,
  ...one22WeBshangpinjiagebanbenguanli,
  ...one02WeBshangpinguanli,
  ...one24WeBshangpinguizeguanli,
  ...one26WeBcaidanguanli,
  ...one27WeBquanxiantiaomu,
  ...one09WeBzhajiguanli,
  ...one19WeBzidianguanli,
  ...one14WeBbumenguanli,
  ...one18WeBtousuguanli,
  ...one20WeBjiaolianguanli,
  ...one10WeBshouhuanjiguanli,
  ...one11WeBshouhuanguanli,
  ...one15WeBbannerguanli,
  ...one21WeBnianlingzuguanli,
  ...five5ApPyonghuzhanghudaoru,
  ...five4ApPyonghuzhanghuxinxi,
  ...three01Machineshouhuanjihuidiao,
  ...zero06BasEwenjianguanli,
  ...two08ApPyouyongzheguanli,
  ...two04ApPhuodong,
  ...two07ApPdingdan,
  ...two01ApPhuiyuan,
  ...two03ApPchangguan,
  ...two05ApPshangpin,
  ...two10ApPtousufankui,
  ...two06ApPgouwuche,
  ...two11ApPzhifuguanli,
  ...renzhengquanxian,
  ...two09ApPyonghuxieyi,
  ...two02ApPbanner,
  ...nine00Guanlidingshiqishoudongzhixing,
};

export async function post<T = any>(
  url: string,
  data: any,
  options?: { [key: string]: any }
) {
  return request<API.ResponseVO<T>>(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data,
    ...(options || {}),
  });
}

export async function get<T = any>(
  url: string,
  data: any,
  options?: { [key: string]: any }
) {
  return request<API.ResponseVO<T>>(url, {
    method: "GET",
    params: data,
    ...(options || {}),
  });
}
